import { Component, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { OrgDetails } from 'src/app/services/administration/analytics.service';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import * as $ from 'jquery';

@Component({
    selector: 'app-application-type-modal',
    standalone: false,
    templateUrl: './application-type-modal.component.html',
    styleUrl: './application-type-modal.component.scss'
})
export class ApplicationTypeModalComponent {

    modulelist: any;
    appTypeForm: UntypedFormGroup;
    @Input() public Content: any;
    ProgramId: any[];
    ConfigurationId: any[];
    ComplianceId: any[];
    InstructionsId: any[];
    WorkflowId: any[];

    constructor(
        private summaryService: AdministrationSummaryService,
        public modalRef: NgbActiveModal,
        private appFunctions: AppFunctionsService,
        private modalService: NgbModal,
        private commonservice: CommonService,
        private userService: UserService
    ) { }

    ngOnInit() {
       
        this.appTypeForm = new UntypedFormGroup(
            {
                ID: new UntypedFormControl(""),
                NAME: new UntypedFormControl("", [Validators.required, Validators.maxLength(100)]),
                POLICY_CONFIG_ID: new UntypedFormControl("", [Validators.required]),
                COMPLIANCE_STATEMENT_ID: new UntypedFormControl(""),
                ID_CONFIGURATION_ID: new UntypedFormControl("", [Validators.required]),
                PROGRAM_ID: new UntypedFormControl("", [Validators.required]),
                PROGRAM_CODE: new UntypedFormControl(""),
                USER_INSTRUCTIONS_ID: new UntypedFormControl(""),
                RECORD_STATE: new UntypedFormControl(true),
            });
            this.GetMasterData() ;
        if (this.Content.heading == "View") {
            this.GetEditData();
            this.appTypeForm.disable();
        }
        if (this.Content.heading == "Edit") {
         
            this.GetEditData();

        }
    }


   
    GetEditData(): void {
      
            this.summaryService.getSummaryData('api/apptype/Edit?RecordID=' + this.Content.content.id).subscribe(summary => {
              this.appTypeForm.patchValue({
                ID: summary["ID"],
                NAME: summary["NAME"],
                RECORD_STATE: summary["RECORD_STATE"] == 1 ? true : false,
                PROGRAM_ID: summary["PROGRAM_ID"],
                PROGRAM_CODE: summary["PROGRAM_CODE"],
                POLICY_CONFIG_ID: summary["POLICY_CONFIG_ID"],
                COMPLIANCE_STATEMENT_ID: summary["COMPLIANCE_STATEMENT_ID"],
                USER_INSTRUCTIONS_ID: summary["USER_INSTRUCTIONS_ID"],
                ID_CONFIGURATION_ID: summary["ID_CONFIGURATION_ID"],
              });
              this.onOptionsSelected(null);
              if (this.Content.heading == "View") {
                this.appTypeForm.disable();
              }
              else if (this.Content.heading == "Edit"){
                this.appTypeForm.controls["PROGRAM_ID"].disable();
                
              }             
            });

    }


    GetMasterData() {
       
        this.summaryService.GetMasterScreenData("api/apptype/GetMasterScreenData?RecordID=" + this.Content.content.id).subscribe(summary => {
          this.ProgramId = summary["MasterData1"];
          this.ProgramId = [{ label: "Select", value: "", checked: true }].concat(this.ProgramId);
         
        });
      }

      onOptionsSelected(event: any){
                
        let moduleID = this.appTypeForm.controls["PROGRAM_ID"].value;
       
        this.summaryService.GetMasterScreenData("api/apptype/GetMasterScreenData?RecordID=" + this.Content.content.id +"&ModuleName="+moduleID).subscribe(summary => {
          this.InstructionsId = summary["MasterData2"];
          this.InstructionsId = [{ label: "Select", value: "", checked: true }].concat(this.InstructionsId);
          this.WorkflowId = summary["MasterData3"];
          this.WorkflowId = [{ label: "Select", value: "", checked: true }].concat(this.WorkflowId);
          this.ComplianceId = summary["MasterData4"];
          this.ComplianceId = [{ label: "Select", value: "", checked: true }].concat(this.ComplianceId);
          this.ConfigurationId = summary["MasterData5"]
          this.ConfigurationId = [{ label: "Select", value: "", checked: true }].concat(this.ConfigurationId);
        });

      }
    save() {
        if (this.validateControls()) {
          var formDate = this.appTypeForm.getRawValue();
          formDate.NAME=formDate.NAME==null?null:formDate.NAME==undefined?undefined:formDate.NAME.trim();
          formDate.RECORD_STATE = this.appTypeForm.controls["RECORD_STATE"].value ? 1 : 0;
          
          if (this.Content.heading == "Add") {
            formDate["ID"] = this.Content.content.id;
            this.summaryService.Insert('api/apptype/Insert', formDate).subscribe(summary => {
              if (summary.Status == 0) {
                this.modalRef.close();
                this.commonservice.SuccessBanner(summary.Message);
                this.appTypeForm.controls["ID"].setValue(this.Content.content.id);
              }
              else {
                this.commonservice.ValidationBanner(summary.Message);
              }
            });
          }
          else {
            let isValid = true;
            let message = "";
            let polCon = this.WorkflowId.filter((item) => {
              return item.value == formDate.POLICY_CONFIG_ID;
            })[0];
          
          if(polCon!=null && polCon!=undefined && polCon.IsActive == false)
            {
              message += "Please remove inactive workflow setup value to save the details <br/>";
              isValid = false;
            }
            let userIns = this.InstructionsId.filter((item) => {
              return item.value == formDate.USER_INSTRUCTIONS_ID;
            })[0];
          
            let validVar=false;
            if(userIns != "" && userIns != null && userIns != undefined && userIns.IsActive == false )
              {
                message += "Please remove deleted/inactive user instruction/compliance statement to save the details <br/>";
                isValid = false;
                validVar=true;
              }

              let comp = this.ComplianceId.filter((item) => {
                return item.value == formDate.COMPLIANCE_STATEMENT_ID;
              })[0];
              if(validVar==false && comp != "" && comp != null && comp != undefined && comp.IsActive == false )
              {
                  message += "Please remove deleted/inactive user instruction/compliance statement to save the details <br/>";
                  isValid = false;
              }
           
            let idConfig = this.ConfigurationId.filter((item) => {
              return item.value == formDate.ID_CONFIGURATION_ID;
            })[0];
          if(idConfig!=null && idConfig!=undefined && idConfig.IsActive == false)
            {
              message += "Please remove inactive ID configuration to save the details <br/>";
              isValid = false;
            }
            if(!isValid)
              this.commonservice.ValidationBanner(message);
            
            else{
              this.summaryService.Insert('api/apptype/Update', formDate).subscribe(summary => {
                if (summary.Status == 0) {
                  this.modalRef.close();
                  this.commonservice.SuccessBanner(summary.Message);
                }
                else {
                
                  this.commonservice.ValidationBanner(summary.Message);
                }
              });
            }
            
             
          }
         }
    
      }
      validateControls(): boolean {
        let isValid = true;
        let message = "";
        const formData = this.appTypeForm.getRawValue();
    
        if (formData.NAME === null || formData.NAME === ""||formData.NAME===undefined) {
          $("#NAME").addClass("ng-touched ng-invalid validate-error");
          $("#NAME").removeClass("ng-untouched ng-valid");
          message += "Please enter Name <br/>";
          isValid = false;
        }else if(formData.NAME !=null&&formData.NAME !=undefined &&formData.NAME.trim()==""){
          $("#NAME").addClass("ng-touched ng-invalid validate-error");
          $("#NAME").removeClass("ng-untouched ng-valid");
          message += "Please enter Name <br/>";
          isValid = false;
        } 
        else {
          $("#NAME").addClass("ng-untouched ng-valid");
          $("#NAME").removeClass("ng-touched ng-invalid validate-error");
        }
    
        if (formData.PROGRAM_ID === null || formData.PROGRAM_ID === ""||formData.PROGRAM_ID===undefined) {
            $("#PROGRAM_ID").addClass("ng-touched ng-invalid validate-error");
            $("#PROGRAM_ID").removeClass("ng-untouched ng-valid");
            message += "Please select Program <br/>";
            isValid = false;
          }
          else {
            $("#PROGRAM_ID").addClass("ng-untouched ng-valid");
            $("#PROGRAM_ID").removeClass("ng-touched ng-invalid validate-error");
          }

          if (formData.POLICY_CONFIG_ID === null || formData.POLICY_CONFIG_ID === ""||formData.POLICY_CONFIG_ID===undefined) {
            $("#POLICY_CONFIG_ID").addClass("ng-touched ng-invalid validate-error");
            $("#POLICY_CONFIG_ID").removeClass("ng-untouched ng-valid");
            message += "Please select Workflow Setup <br/>";
            isValid = false;
          }
          else {
            $("#POLICY_CONFIG_ID").addClass("ng-untouched ng-valid");
            $("#POLICY_CONFIG_ID").removeClass("ng-touched ng-invalid validate-error");
          }

          if (formData.ID_CONFIGURATION_ID === null || formData.ID_CONFIGURATION_ID === ""||formData.ID_CONFIGURATION_ID===undefined) {
            $("#ID_CONFIGURATION_ID").addClass("ng-touched ng-invalid validate-error");
            $("#ID_CONFIGURATION_ID").removeClass("ng-untouched ng-valid");
            message += "Please select ID Configuration <br/>";
            isValid = false;
          }
          else {
            $("#ID_CONFIGURATION_ID").addClass("ng-untouched ng-valid");
            $("#ID_CONFIGURATION_ID").removeClass("ng-touched ng-invalid validate-error");
          }
          
          
        if (!isValid)
          this.commonservice.ValidationBanner(message);
        return isValid;
      }
    }
